module.exports = __webpack_public_path__ + "img/mine-btn.e1f625f1.png";